const SearchReducer = (state, action) => {
  switch (action.type) {
    case 'SEARCH_HYDRATED_UPDATE':
      return {...state, hydrated: action.data};
    case 'SEARCH_VALUE_UPDATE':
      return {...state, value: action.data};
    case 'SEARCH_RESULTS_UPDATE':
      return {...state, results: action.data};
    case 'SEARCH_FILTER_UPDATE':
      const currentFilter = [...state.activeFilter];
      const index = currentFilter.indexOf(action.data);
      if (index > -1) {
        currentFilter.splice(index, 1);
      } else {
        currentFilter.push(action.data);
      }
      return {...state, activeFilter: currentFilter};
    case 'SEARCH_HISTORY_UPDATE':
      return {...state, history: action.data};
    default:
      return state;
  }
};

export default SearchReducer;
